import { tokens } from "@/shared/design-system/tokens";
import styled from "@emotion/styled";

const InputContainer = styled.div<{ $maxWidth?: string }>`
  display: flex;
  flex-direction: column;
  gap: ${tokens.spacing.xs};
  max-width: ${(props) => (props.$maxWidth !== "" ? props.$maxWidth : "264px")};
  min-width: 8px;
`;

const Label = styled.label`
  width: fit-content;
  font-size: 12px;
  font-weight: 400;
  color: #fafafa;
`;

const Advice = styled.span`
  font-size: 0.75em;
  font-weight: 400;
  color: red;
  padding-left: 2px;
  margin-top: 2px;
`;

const InputHTML = styled.input<{ $inputwidth: string }>`
  box-sizing: border-box;
  padding: 10px 12px;
  border-radius: 4px;
  border: 2px solid rgba(11, 62, 95, 0.5);
  background-color: #8fb6c7;
  color: #0b3e5f;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  height: 40px;
  width: ${({ $inputwidth }) => $inputwidth ?? "100%"};

  b &::placeholder {
    color: #c8c8c8;
    font-family: Poppins;
  }

  &:focus {
    outline: none;
  }
`;

export { InputContainer, Label, InputHTML, Advice };
